<template>
  <div v-if="isLoading" class="loading-animation-ai">
    <SvgIcon v-if="isUS" name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" class="logo" />
    <img v-if="isAustralia" :src="require('@/assets/img/toolbar-white-logo.png')" alt="Locumate">

    <!-- Display the current message -->
    <p v-if="currentMessage" class="ai-animated-text">{{ currentMessage }}</p>
    
    <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" class="ai-icon">
          <path
            class="path1"
            d="M63 30L64.3635 37.9373C66.1158 48.1374 72.4901 56.1052 80.6502 58.2956L87 60L80.6502 61.7044C72.4901 63.8948 66.1158 71.8626 64.3635 82.0627L63 90L61.6365 82.0627C59.8842 71.8626 53.5099 63.8948 45.3498 61.7044L39 60L45.3498 58.2956C53.5099 56.1052 59.8842 48.1374 61.6365 37.9373L63 30Z"
            fill="rgb(var(--locumate-secondary-color))" />
          <path
            class="path2"
            d="M33 6L34.0227 11.5561C35.3369 18.6962 40.1176 24.2737 46.2377 25.8069L51 27L46.2376 28.1931C40.1176 29.7263 35.3369 35.3038 34.0227 42.4439L33 48L31.9773 42.4439C30.6631 35.3038 25.8824 29.7263 19.7624 28.1931L15 27L19.7624 25.8069C25.8824 24.2737 30.6631 18.6962 31.9773 11.5561L33 6Z"
            fill="rgb(var(--locumate-secondary-color))" />
          <path
            class="path3"
            d="M21 54L21.6818 57.9686C22.5579 63.0687 25.7451 67.0526 29.8251 68.1478L33 69L29.8251 69.8522C25.7451 70.9474 22.5579 74.9313 21.6818 80.0314L21 84L20.3182 80.0314C19.4421 74.9313 16.2549 70.9474 12.1749 69.8522L9 69L12.1749 68.1478C16.2549 67.0526 19.4421 63.0687 20.3182 57.9686L21 54Z"
            fill="rgb(var(--locumate-secondary-color))" />
        </svg>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted,watch, emit, computed } from 'vue';
import SvgIcon from '@/components/Svg/SvgIcon.vue';
import { useStore } from "vuex";

export default {
  props: {
    isUS: Boolean,
    isAustralia: Boolean,
    isLoading: Boolean,  // Ensure this prop is correctly passed and is `true` when you want to start loading
  },
  components:{
    SvgIcon,
  },
  setup(props) {
    // Messages to be shown

    const $store = useStore();
    const pharmacyMessages = [
  "We’re mixing up the perfect prescription for your next great hire – almost ready!",
  "Your job ad is in the lab, cooking up the right formula for top pharmacy talent!",
  "Just a spoonful of patience – your next pharmacy star is almost on the way!",
  "Hang tight! We’re compounding the perfect job ad to fill your pharmacy’s needs.",
  "Our AI is shaking up the job market... and your ad will be ready in no time!",
  "Like the perfect blend of meds, your job ad is being tailored for the best results!",
  "Pharmacy talent in 30 seconds or less – faster than your average prescription!",
  "We’re filling your prescription for a great pharmacist – your ad is almost ready!",
  "Hold on! Your pharmacy dream team is just a job ad away – we’re brewing it now!",
  "Our AI is in the pharmacy lab, preparing a custom job ad to cure your hiring headaches!"
]

const defaultMessages = [
  "Our AI is blending your pharmacy expertise into the perfect profile!",
  "Crafting a profile that showcases your pharmacy skills—AI is on it!",
  "AI is compounding your experience into a profile that stands out in the pharmacy world!",
  "Your pharmacy career is being formulated into a profile that shines!",
  "Watch as AI transforms your CV into a profile that highlights your pharmaceutical talents!",
  "AI is curating a profile that captures your unique pharmacy expertise!",
  "Your pharmacy skills are being distilled into a profile that gets noticed!",
  "Let AI work its magic, creating a profile that highlights your pharmacy career!",
  "Your experience is being crafted into a pharmacy-specific profile that stands out!",
  "AI is synthesizing your pharmacy knowledge into a profile that’s ready for the next step!"
]

const userData = $store.getters.GET_USER_DATA;
const userRole = userData.role; 

const messages = computed(() => {
  return userRole === 'pharmacy' ? pharmacyMessages : defaultMessages
})

    const currentMessage = ref('');  // Initially empty, will hold the message
    const messageIndex = ref(0);    // Index for the messages
    let messageInterval = null;     // Holds the interval reference for cycling messages

    // Function to cycle through messages
    const cycleMessages = () => {
      messageInterval = setInterval(() => {
        messageIndex.value = (messageIndex.value + 1) % messages.value.length; // Increment and loop over messages
        currentMessage.value = messages.value[messageIndex.value]; // Set new message
        console.log('Current Message:', currentMessage.value); // Log the current message
      }, 2000); // Change message every 2 seconds
    };

    // Start loading logic and initialize message display
    const startLoading = () => {
      console.log('Loading started'); // Log when loading starts
      currentMessage.value = messages.value[messageIndex.value]; // Set initial message
      console.log('Initial Message:', currentMessage.value); // Log the initial message
      cycleMessages(); // Begin cycling messages
    };

    // Stop loading when process is done
    const stopLoading = () => {
      clearInterval(messageInterval);
      currentMessage.value = ''; // Clear the message
      emit('stopLoading');
    };

    // Watch for changes in isLoading
    watch(
      () => props.isLoading,
      (newVal) => {
        if (newVal) {
          startLoading();
        } else {
          stopLoading();
        }
      }
    );

    // Watch for the loading state to change and start loading when `isLoading` is true
    // watchEffect(() => {
    //   if (props.isLoading) {
    //     console.log('isLoading is true'); // Debugging: Check when loading is triggered
    //     startLoading();  // Trigger the message cycling when loading starts
    //   } else {
    //     stopLoading();  // Stop when loading ends
    //   }
    // });

    // Ensure messages start when component is mounted and isLoading is true
    onMounted(() => {
      console.log('Component mounted');
      if (props.isLoading) {
        startLoading(); // Ensure messages start if isLoading is true on mount
      }
    });

    // Cleanup interval when component is unmounted
    onUnmounted(() => {
      console.log('Component unmounted');
      clearInterval(messageInterval); // Clear interval if the component is destroyed
    });

    return {
      currentMessage,
      userData,
      userRole,
      pharmacyMessages,
      defaultMessages,
    };
  },
};
</script>

<style scoped>
.ai-animated-text {
  font-size: 1.2em;
  color: #ffffff;
}
</style>
